let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3XeDU")).then(() => parcelRequire('gf2E5'));